import { render, staticRenderFns } from "./BuyFinishList.vue?vue&type=template&id=707ba218&scoped=true"
import script from "./BuyFinishList.vue?vue&type=script&lang=js"
export * from "./BuyFinishList.vue?vue&type=script&lang=js"
import style0 from "./BuyFinishList.vue?vue&type=style&index=0&id=707ba218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707ba218",
  null
  
)

export default component.exports